module.exports = __webpack_public_path__ + "static/img/page6.80e3ef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/page6.png
// module id = HCQE
// module chunks = 2